import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = ({
  images = [],
  sliderClassName,
  slidesToShow = 1,
  arrows = false,
  dots = false,
  infinite = false,
  autoplay = true,
}) => {
  const settings = {
    dots,
    arrows,
    infinite,
    speed: 2000,
    autoplaySpeed: 5000,
    slidesToShow,
    slidesToScroll: 1,
    autoplay,
    className: sliderClassName ? sliderClassName : null,
  };
  return (
    <Slider {...settings}>
      {images &&
        images.map((image, index) => (
          <div key={index}>
            <img
              style={{
                width: "100%",
                height: "100%",
                aspectRatio: "4/3",
                objectFit: "cover",
              }}
              alt={image.title}
              src={image.sizes.medium_large}
              height={image.sizes["medium_large-height"]}
              width={image.sizes["medium_large-width"]}
            />
          </div>
        ))}
    </Slider>
  );
};
export default ImageSlider;
